import { useNavigate } from 'react-router-dom'
import donationApi from '../../../apis/donationApi'
import styles from './ProvinceItem.module.scss'
import {useEffect, useState} from 'react'

interface ProvinceItemProps {
  reload: boolean;
}

const ProvinceItem = (props: ProvinceItemProps) => {
  const [quantityOrder, setQuantityOrder] = useState(0);
  const isDriver = localStorage.getItem("userRole") === "driver";
  const driverId = localStorage.getItem("driverId");
  useEffect(() => {
    (async () => {
      try {
        const payload = {
          filter: {
            provinceId: "202",
            shippingTypeId: "11123",
            statuses: ["new", "confirm", "processing"],
            ...(isDriver && driverId ? { driverId } : {}),
          },
        };
        const res = await donationApi.countOrder(payload);
        if (res.data.code === 0) {
          setQuantityOrder(res.data.data.quantity);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [props.reload, isDriver, driverId]);
    
    return (
        <div className={styles.provinceIt}>
            <p>Hồ Chí Minh({quantityOrder} đơn)</p>
        </div>
    )
}

export default ProvinceItem